/* eslint-disable max-len */
/**
 * Translations.
 */
export default {
  ACTION: {
    CANCEL: 'Cancelar',
    CONFIRM: 'Confirmar',
    CONFIRM_POLL_RESPONSE: 'Confirmar resposta',
    CONTINUE: 'Continuar',
    COPY: 'Copiar',
    DELETE: 'Apagar',
    DELETE_MESSAGE: 'Apagar mensagem',
    EDIT: 'Editar',
    FINISH: 'Finalizar',
    HIDE_ANSWERS: 'Esconder respostas',
    LETS_GET_STARTED: 'Claro, vamos começar',
    MARK_AS_UNREAD: 'Marcar como não lida',
    REPLY: 'Responder',
    SEE_ANSWERS: 'Ver respostas',
    START_SURVEY: 'Iniciar inquérito'
  },
  ERROR: {
    ASSET_SIZE_EXCEEDED: 'O tamanho máximo de um ficheiro é {size}MB',
    CLASSIFICATION_ALREADY_IN_USE:
      'A sondagem expirou porque já existe uma campanha para esta categoria.',
    ERROR_CREATING_NEW_SUGGESTION: 'Erro ao criar nova oferta',
    ERROR_SAVING_PRODUCT_REVIEW: 'Erro ao guardar a avaliação do produto',
    ERROR_SENDING_MESSAGE: 'Erro ao enviar a mensagem',
    ERROR_SUBMITTING_SURVEY: 'Erro ao submeter o inquérito',
    IMAGE_SIZE_EXCEEDED: 'O tamanho máximo de uma imagem é {size}MB',
    MESSAGE_ALREADY_READ:
      'Esta mensagem já não pode ser editada porque já foi lida.',
    UPLOADED_ASSETS_EXCEED: 'O número máximo de ficheiros é {limit}',
    VIDEO_SIZE_EXCEEDED: 'O tamanho máximo de um video é {size}MB'
  },
  HEADER: {},
  LABEL: {
    ACTIONS: 'Ações',
    ADDITIONAL_COMMENTS_QUESTION: 'Comentário adicional?',
    ANSWERED_ON: 'Respondido a {date}',
    CONTACT_OWNER:
      'Algo correu mal. Por favor entra em contacto com o teu gestor',
    CREATE_NEW_CAMPAIGN_SUGGESTION: 'Clica aqui para gerar nova oferta',
    EDITED: 'Editada',
    EXPIRED_ON: 'Expirou a {date}',
    LAST_READ: 'Última lida',
    POLL_CAMPAIGN_EXPIRED: 'ℹ️ Oferta expirada',
    POLL_CAMPAIGN_FOOTER:
      'ℹ️ Ao aceitares, a campanha será criada com início amanhã.\nReceberás também amanhã a mensagem com o poster para partilhar.\nEsta oferta estará disponível durante 3 dias.',
    QUANTITY: 'Quantidade',
    REACT: 'Reagir',
    REACTIONS: 'Reações',
    RESPOND_BY: 'Responder até {date}',
    SEE_PRODUCTS: 'Ver produtos',
    SEEN: 'Visto',
    SELECT_ADDRESS: 'Selecionar morada',
    SELECT_ONE_OPTION: 'Seleciona uma opção',
    SELECT_ONE_OR_MORE_OPTION: 'Seleciona uma ou mais opções',
    SENT: 'Enviado',
    SWIPE_TO_CANCEL: 'Desliza para cancelar',
    TYPE_NEW_MESSAGE: 'Escreve uma nova mensagem',
    VOICE_MESSAGE: 'Mensagem de voz'
  },
  SENTENCE: {
    CONFIRM_POLL_INTERNAL_ORDER:
      'Esta ação irá confirmar a encomenda e não será possível alterar a resposta. Tens a certeza que queres continuar?',
    DELETE_MESSAGE_CONFIRM: 'Tens a certeza que queres apagar esta mensagem?',
    GIVE_OPINION_ABOUT_PRODUCT:
      'Podes dar-nos a tua opinião sobre este produto?',
    MESSAGE_DELETED: 'Esta mensagem foi apagada'
  },
  SUCCESS: {},
  TOOLTIP: {}
};
